export const cs = {
    editorSessionExpired: 'Doba editace vypršela',
    editorDelete: 'Odstranit',
    editorEdit: 'Editovat',
    editorCancel: 'Zrušit',
    editorSubmit: 'Zadat',
    editorTemplatesTitle: 'Šablony',
    editorTemplatesCreate: 'Vytvořit novou šablonu',
    editorTemplatesSetNewName: 'Přejmenovat formát',
    editorTemplatesCreateNew: 'Vytvořit nový formát šablony',
    editorTemplatesName: 'Název formátu',
    editorTemplatesWidth: 'Šířka formátu [mm]',
    editorTemplatesHeight: 'Výška formátu [mm]',
    editorTemplatesBleed: 'Nastavení spadávky [mm]',
    editorTemplatesEditName: 'Editovat {formatName} název',
    editorTemplateWarning: 'Tento formát je používán v některých projektech. Spolu s odstraněním formátu budou tyto projekty odstraněny. Chcete pokračovat?', //This format contains projects. Deleting a format means deleting projects. Do you want to continue?
    editorTemplateRemove: 'Ano, opravdu odstranit formát spolu s projekty',
    editorProjectsTitle: 'Šablony > Projekty',
    editorProjectsCreateNew: 'Vytvořit nový projekt',
    editorProjectsName: 'Název projektu',
    editorProjectsDescription: 'Popis projektu',
    editorProjectsWarning: 'Tento projekt není prázdný. Spolu s odstraněním budou odstraněny zde použité prvky. Opravdu pokračovat?',
    editorProjectsRemove: 'Ano, opravdu odstranit projekt spolu s prvky.',
    editorProjectEdit: 'Editovat projekt',
    editorPlaceholdersTitle: 'Zástupné znaky',
    editorPlaceholdersName: 'Název',
    editorPlaceholdersSystemName: 'Název systému',
    editorPlaceholdersAddNew: 'Přidat další',
    editorPlaceholdersCreateNew: 'Vytvořit nový',
    editorPlaceholdersUpdate: 'Aktualizovat zástupný znak',
    editorPlaceholdersRemove: 'Odstranit',
    editorTabItemProjects: 'Projekty',
    editorTabItemUploads: 'Nahrát',
    editorTabItemFrames: 'Rámečky',
    editorTabItemText: 'Přidat text',
    editorTabItemShapes: 'Tvar',
    editorTabItemForms: 'Formulář',
    editorTabFontTitle: 'Vybrat písmo',
    editorTabTextNewItemContent: 'Dvojitým kliknutím zahájíte editaci. Klikněte a tažením přesuňte.',
    editorTabShapesTitle: 'Základní tvary',
    editorTabQrTitle: 'QR kód',
    editorTabQrNewItemContent: 'Text QR kódu',
    editorTabFrameTitle: 'Klikněte a přidejte rámeček obrázku',
    editorTabImagesTitle: 'Nahrané obrázky',
    editorTabImagesUpload: 'Nahrát obrázek',
    editorTabImagesSetBackground: 'Nastavit obrázek jako pozadí',
    editorTabImagesProcessing: 'Zpracovává se...',
    editorTabHideFromUser: 'Skrýt před uživatelem',
    editorTabShow: 'Zobrazit vše',
    editorTabPlaceholdersContent: 'Obsah zástupného znaku',
    editorTabProjectsBack: 'Zpět k projektům',
    editorTabProjectsWarning: 'Pozor!',
    editorTabProjectsOverwrite: 'V tomto rozložení jsou data nastavena odlišným způsobem. Část vaší práce může být přepsána.',
    editorTabProjectsApplyNewLayout: 'Použít nové rozložení',
    editorTabProjectsHide: 'Skrýt',
    editorTabProjectsNoLayouts: 'Nemáte žádné projekty v tomto formátu.',
    editorSceneProjectId: 'Číslo projektu:',
    editorScenePriceConfig: 'Konfigurace produktu',
    editorScenePriceSummary: 'Souhrn',
    editorScenePriceNet: 'Cena bez DPH',
    editorScenePriceVAT: 'DPH',
    editorScenePriceTotal: 'Cena s DPH',
    editorSceneElementOptionsAdjustImage: 'Upravit obrázek',
    editorSceneElementOptionsLastUsedColors: 'Poslední použité barvy',
    editorSceneElementOptionsWidth: 'Šířka',
    editorSceneElementOptionsHeight: 'Výška',
    editorSceneElementOptionsSize: 'Rozměr',
    editorSceneElementOptionsColors: 'Barvy',
    editorSceneElementOptionsSetQRSize: 'Nastavit velikost QR',
    editorSceneElementOptionsSetQRColor: 'Nastavit barvu QR',
    editorSceneElementOptionsDelete: 'Odstranit prvek',
    editorSceneElementOptionsLock: 'Uzamknout prvek',
    editorSceneElementOptionsNoPlaceholder: 'Zástupný znak nebyl zvolen',
    editorSceneElementOptionsSetPlaceholder: 'Nastavit prvek zástupného znaku',
    editorSceneElementOptionsSetPosition: 'Nastavit pozici prvku',
    editorSceneElementOptionsSetVisibility: 'Ukázat/skrýt seznam prvků',
    editorSceneElementOptionsPushToFront: 'Přenést prvek do popředí',
    editorSceneElementOptionsPushToBack: 'Přenést prvek do pozadí',
    editorSceneElementOptionsFontFamily: 'Vybrat typ písma',
    editorSceneElementOptionsFontWeight: 'Vybrat řez písma',
    editorSceneElementOptionsFontSize: 'Vybrat velikost písma',
    editorSceneElementOptionsTextAlign: 'Zarovnat text',
    editorSceneElementOptionsTextCapitalize: 'Velká písmena',
    editorSceneElementOptionsTextUnderline: 'Podtržená písmena',
    editorSceneElementOptionsPublishProject: 'Publikovat projekt',
    editorSceneElementOptionsPublished: 'Projekt byl opublikován',
    editorSceneElementOptionsPublish: 'Publikovat',
    editorSceneElementOptionsSave: 'Uložit projekt',
    editorSceneElementOptionsSaveDesign: 'Uložit návrh',
    editorSceneElementOptionsSaveAndAdd: ' a přidat do košíku',
    editorSceneElementOptionsValidationErrorMsg: 'Prvky nebyly potvrzeny. Opravte je a uložte projekt.',
    editorSceneElementOptionsValidationValue: 'Parametry prvku:',
    editorSceneElementOptionsValidationError: 'chyba:',
    editorScenePageBackgroundSettings: 'Nastavení pozadí stránky',
    editorScenePageBackgroundSize: 'Velikost pozadí',
    editorScenePageBackgroundCustomSize: 'Vlastní velikost',
    editorScenePageBackgroundPosition: 'Umístění pozadí',
    editorScenePageBackgroundRepeat: 'Kopírovat pozadí',
    editorScenePageBackgroundAdditional: 'Další možnosti',
    editorScenePageBackgroundRemove: 'Odstranit pozadí',
    editorScenePageBackgroundColor: 'Barva pozadí',
    editorScenePageCornerRadius: 'Zaoblit rohy na stránce',
    editorScenePageNumber: 'Stránka {num1} z {num2}',
    editorScenePageShowPrevious: 'Zobrazit předchozí stránku',
    editorScenePageShowNext: 'Zobrazit další stránku',
    editorScenePageSettings: 'Nastavení stránky',
    editorScenePageAddNew: 'Přidat další stránku',
    editorScenePageDelete: 'Odstranit stránku',
    editorScenePageLock: 'Uzamknout stránku',
    editorScenePageWarning: 'Tato stránka není prázdná. Chcete pokračovat?',
    editorScenePageDeleteConfirm: 'Ano, opravdu vymazat stránku'
}